export default {
  create: {
    title: 'Add',
    subtitle: 'Letrex',
  },
  edit: {
    title: 'Edit',
    subtitle: 'Letrex',
    button: {
      add: 'New game',
    },
  },
  list: {
    title: 'Letrex',
    subtitle: 'List',
    add: 'New game',
  },
  card: {
    title: 'Letrex',
    actions: 'Actions',
  },
  table: {
    title: 'Active games',
    searchPlaceholder: 'Search...',
  },
  form: {
    name: {
      label: 'Name:',
      placeholder: 'E.g.: Letrex Level 1',
      invalid: 'Name is required',
    },
    rows: {
      label: 'Rows:',
    },
    columns: {
      label: 'Columns:',
    },
    level: {
      label: 'Level:',
      placeholder: 'Select the level...',
    },
    generationMode: {
      label: 'Generation mode:',
      placeholder: 'Select the mode...',
      options: {
        simple: 'Simple',
        distribution: 'Distribution',
      },
    },
    wordLengthRange: {
      section: 'Distribution',
      min: {
        label: 'Minimum length',
        tooltip: 'Minimum length of generated words.',
      },
      max: {
        label: 'Maximum length',
        tooltip: 'Maximum length of generated words.',
      },
    },
    prioritizeQuality: {
      label: 'Prioritize quality',
      tooltip:
        'Runs extra attempts after the main generation to try to improve the result. May take longer.',
    },
    avoidSimilarWords: {
      label: 'Avoid similar words',
      tooltip:
        'The system will avoid words that are significantly similar to words already present in the grid.',
    },
    wordsList: {
      label: 'Word list:',
      copyTooltip: 'Copy list to clipboard',
    },
    grid: {
      cellLabel: 'Cell row {row}, column {col}',
    },
  },
  sidebar: {
    exportHint: 'You need to save before exporting.',
    defaultFileName: 'letrex',
  },
  button: {
    generate: 'Generate game',
  },
  alert: {
    gameSaved: 'Game saved successfully!',
    cleared: 'Grid cleared successfully!',
    generated: 'Letrex generated successfully!',
    generateFailed: 'Could not generate the Letrex.',
    wordLengthRangeInvalid:
      'Enter a valid word length range (min ≤ max).',
    wordsListCopied: 'Word list copied!',
    wordsListCopyFailed: 'Could not copy the word list.',
    sendSuccess: 'Sent successfully',
    sendError: 'Error sending. Please try again.',
  },
};
